export default __webpack_public_path__ + "static/media/07_photo.db47c383.jpg";